<mat-sidenav-container class="page-layout carded fullwidth inner-scroll h-100-p" *ngIf="(uxInteractions$ | async) as uxInteractions">
  <div id="adm1n-users-list" class="page-layout carded small-top right-sidebar inner-scroll h-100-p">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center h-100-p">
      <!-- HEADER -->
      <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">
        <!-- APP TITLE -->
        <div fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="['/']">
            <mat-icon>arrow_back</mat-icon>
          </button>

          <div fxLayout="column" fxLayoutAlign="start start" [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
            <div class="h2">{{ title|translate }}</div>
            <div class="subtitle secondary-text">
              {{nbVisibleRow | number}} /
              {{ usersList?.length || 0 | number }}
            </div>
          </div>
        </div>
        <!-- / APP TITLE -->
        <span fxFlex></span>

        <button *ngIf="currentUserType==='client'" mat-raised-button (click)="openCreateUserDialog()">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="currentColor" d="M15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4M15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1A2.1,2.1 0 0,1 12.9,8A2.1,2.1 0 0,1 15,5.9M4,7V10H1V12H4V15H6V12H9V10H6V7H4M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1H8.9V17C8.9,16.36 12,14.9 15,14.9Z"/>
          </svg>
          Add user
        </button>

        <app-user-create></app-user-create>

        <button mat-raised-button class="button-menu-bar ml-24" (click)="displayExtSelector()">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="currentColor" d="M15 17H18V14H20V17H23V19H20V22H18V19H15V17M13 19.88C13.04 20.18 12.94 20.5 12.72 20.71C12.32 21.1 11.69 21.1 11.3 20.71L7.29 16.7C7.06 16.47 6.96 16.16 7 15.87V10.75L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3V3H17V3C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L13 10.75V19.88M5.04 5L9 10.07V15.58L11 17.58V10.05L14.96 5H5.04Z"/>
          </svg>
          Filters
        </button>

        <!--        <button mat-raised-button class="button-menu-bar ml-24" (click)="dataGrid.instance.exportToExcel()">-->
        <!--          <i class="mdi mdi-excel"></i>-->
        <!--          Excel-->
        <!--        </button>-->

      </div>
      <!-- / HEADER -->

      <!-- PROGRESS BAR -->
      <!--      <div class="content-card h-100-p" *ngIf="uxInteractions.loading">-->
      <!--        <mat-progress-bar mode="indeterminate"></mat-progress-bar>-->
      <!--      </div>-->
      <!-- PROGRESS BAR -->

      <!-- CONTENT -->
      <div class="content-card grid-container h-100-p w-100-p">

        <div class="content-card grid-container h-100-p w-100-p p-24" *ngIf="uxInteractions.errorMessage" style="overflow: auto;">
          <pre>{{uxInteractions.errorMessage | json}}</pre>
          <br>
          <pre>{{uxInteractions.errorMessageDetailed | json}}</pre>
        </div>

        <ejs-splitter #userListSpliter height='100%' width='100%' separatorSize='5'>
          <e-panes>
            <!-- MAIN VIEW -->
            <e-pane size='50%' [collapsible]='false'>
              <ng-template #content>

                <ng-container *ngIf="!uxInteractions.errorMessage">

                  <div
                    *appLoadingUntil="!uxInteractions.loading;message:'Chargement...'|translate"

                    class="grid-container h-100-p">

                    <dx-data-grid

                      class="allUsersList" id="allusersList"

                      [dataSource]="usersList"
                      [columns]="tableColumns"

                      keyExpr="userId"
                      [(selectedRowKeys)]="selectedUsersId"
                      (onSelectionChanged)="selectUsersId($event)"

                      [height]="'100%'"

                      [showColumnLines]="false"
                      [showRowLines]="false"

                      [showBorders]="true"

                      [rowAlternationEnabled]="false"
                      [hoverStateEnabled]="true"

                      [columnAutoWidth]="false"

                      [showColumnHeaders]="true"

                      [allowColumnReordering]="true"
                      [allowColumnResizing]="true"

                      columnResizingMode="widget"

                      [(filterValue)]="filterValue"

                      (onContentReady)="updateRowsCount()"
                      (onToolbarPreparing)="onToolbarPreparing($event)"
                      (onExporting)="onExporting($event)">
                    >

                      <dxo-load-panel [enabled]="uxInteractions.loading" [shading]="true" [text]="'Refreshing...'"></dxo-load-panel>

                      <dxo-selection [showCheckBoxesMode]="'always'" [mode]="'multiple'" [allowSelectAll]="true"></dxo-selection>
                      <dxo-export [enabled]="true" [fileName]="'Users list export'"></dxo-export>
                      <dxo-search-panel [visible]="true" [width]="'100%'" placeholder="Search..."></dxo-search-panel>
                      <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                      <dxo-group-panel [visible]="true"></dxo-group-panel>

                      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

                      <dxo-column-chooser [enabled]="true"></dxo-column-chooser>

                      <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                      <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

                      <dxo-load-panel [enabled]="true"></dxo-load-panel>

                      <dxo-scrolling mode="virtual" useNative="true" showScrollbar="always"></dxo-scrolling>

                      <!-- Template de la toolbar     -------------------------------------------------------------------------------------------------->
                      <div *dxTemplate="let data of 'toolbarTemplate'">
                        <div fxLayout="row" fxLayoutAlign="space-between center">

                          <div *ngIf="selectedExtProfils.length > 0" fxflex class="mr-16" [formGroup]="displayExtNotEmptyGroup" style="background-color: white;">
                            Ext not empty
                            <mat-select formControlName="selected" multiple>
                              <mat-option *ngFor="let aExt of selectedExtProfils" [value]="aExt">{{aExt}}</mat-option>
                            </mat-select>
                          </div>

                          <div fxFlex class="mr-16">
                            <mat-form-field appearance="standard" style="min-width: 120px;">
                              <mat-label>Type</mat-label>
                              <mat-select value="6" (selectionChange)="changeSwType($event)" [formControl]="contributorsOrClient" multiple>
                                <mat-option value="contributor">Contributors</mat-option>
                                <mat-option value="client">Clients</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div fxFlex class="mr-16">
                            Last connection
                            <mat-select value="6" (selectionChange)="changeLastMonth($event)" [(value)]="nbLastMonth">
                              <mat-option value="1">1 month</mat-option>
                              <mat-option value="6">6 months</mat-option>
                              <mat-option value="12">12 months</mat-option>
<!--                              <mat-option value="24">24 months</mat-option>-->
<!--                              <mat-option value="-1">All</mat-option>-->
                            </mat-select>
                          </div>
                          <button class="button-menu-bar" mat-icon-button (click)="refresh()">
                            <mat-icon>refresh</mat-icon>
                          </button>
                        </div>
                      </div>

                      <!-- Template des colonnes     -------------------------------------------------------------------------------------------------->
                      <div *dxTemplate="let d of 'actionTemplate'" fxLayout="row" fxLayoutAlign="start start" class="buttons-col">
                        <button
                          class="button-menu-bar" mat-icon-button
                                (click)="loginAs(d.data.jwtToken, d.data.type)">
                          <i class="mdi mdi-key-arrow-right"></i>
                        </button>

<!--                        <button *ngIf="d.data.isSaas"-->
<!--                                class="button-menu-bar" mat-icon-button-->
<!--                                (click)="connectAs(d.data.userId, 'saasConnectAs')">-->
<!--                          <i class="mdi mdi-key-star"></i>-->
<!--                        </button>-->

<!--                        <div class="white-space">-->
<!--                          <button *ngIf="d.data.isSaas && !d.data.isSaasSuperAdmin"-->
<!--                                  class="button-menu-bar" mat-icon-button-->
<!--                                  (click)="connectAs(d.data.userId, 'saasConnectAs')">-->
<!--                            <i class="mdi mdi-key-star"></i>-->
<!--                          </button>-->
<!--                        </div>-->
                        <button class="button-menu-bar" mat-icon-button (click)="editUser(d.data.userId)">
                          <i class="mdi mdi-account-edit-outline"></i>
                        </button>
                      </div>

                      <div *dxTemplate="let d of 'loginUrlTemplate'" fxLayout="row" fxLayoutAlign="start start" class="avatar-col">
                        <a href="{{generateLoginAsUrl(d.data.jwtToken)}}">{{generateLoginAsUrl(d.data.jwtToken)}}</a>
                      </div>

                      <div *dxTemplate="let d of 'mediaTemplate'" fxLayout="row" fxLayoutAlign="start start" class="avatar-col">
                        <div *ngIf="!d.data.isSaasSuperAdmin && d.data.userMedia" class="avatar bgAvatar"
                             [ngClass]="d.data.type + '-circle'" [style.background]="'url(' + baseUrl + '/media/' + d.data.userMedia + '/h/40' + ')'">
                        </div>
                        <div *ngIf="
                                  !d.data.isSaasSuperAdmin &&
                                  !d.data.userMedia &&
                                  d.data.type == 'client'
                                  " [ngClass]="d.data.type + '-circle'" class="avatar-icon avatar-circle">
                          <img [src]="'https://avatars.dicebear.com/api/avataaars/'+d.data.userId+'.svg?r=50&topChance=50&accessoriesChance=35&facialHairChance=4&mouth[]=smile&skin[]=yellow'" alt="">
                        </div>
                        <div *ngIf="d.data.type == 'contributor' && !d.data.userMedia" [ngClass]="d.data.type + '-circle'" class="avatar-icon avatar-circle">
                          <img [src]="'https://avatars.dicebear.com/api/avataaars/'+d.data.userId+'.svg'+avatarUrlExt" alt="">
                        </div>
                        <div *ngIf="d.data.isSaasSuperAdmin" class="avatar-icon ">
                          <i class="md-fab mdi mdi-shield-account" [ngClass]="d.data.type"></i>
                        </div>

                        <div *ngIf="d.data.clientSwitched" class="status-icon clientSwitched"></div>

                      </div>
                      <!-- /Template des colonnes     -------------------------------------------------------------------------------------------------->

                    </dx-data-grid>

                  </div>

                </ng-container>

              </ng-template>
            </e-pane>

            <!-- Pane des ext profils (des batch actions en fait) batch edit (A refactoriser dans un sous composant...) ---------------------------------------------------------->
            <e-pane *ngIf="selectedUsersId.length > 0" size='50%' [collapsible]='true'>
              <ng-template #content>

                <div fxLayout="column" class="ext-editor p-8 h-100-p w-100-p">
                  <div fxFlex="50px">
                    <h2>{{selectedUsersId.length}} selected users.</h2>
                  </div>
                  <div fxFlex="150px" style="overflow-y: auto;">
                    <pre>{{selectedUsersEmails|json}}</pre>
                  </div>

                  <mat-tab-group class="user-batch-actions">
                    <mat-tab label="Ext & Emails groups">
                      <ng-template matTabContent>

                        <div fxFlex="100%" fxLayout="column" class="ext-editor p-8 h-100-p w-100-p">
                          <div fxFlex *ngIf="allExtProfils.length === 0" class="text-right">
                            <button mat-button (click)="displayExtSelector()">Select exts profils or ....</button>
                            <button mat-raised-button class="mat-primary" (click)="addAnExt()">... create new one.</button>
                          </div>
                          <div fxFlex="auto" fxLayout="column" fxLayoutAlign="start stretch" *ngIf="allExtProfils.length > 0" style="overflow-y: auto;">

                            <ng-container *ngFor="let anExt of selectedExtProfils; index as i;">
                              <div fxLayout="row" fxLayoutAlign="start center" [ngClass]="{'mark-as-delete': toDeleteExtProfils.includes(anExt)}">

                                <div fxFlex="30" class="key-name">
                                  <span *ngIf="fEditExt.get(anExt).dirty">[!]</span>
                                  <span *ngIf="toDeleteExtProfils.includes(anExt)">[x]</span>
                                  {{anExt}}
                                </div>

                                <mat-form-field fxFlex="60">
                                  <input matInput [formControl]="fEditExt.get(anExt)">
                                </mat-form-field>

                                <div fxFlex="10" fxLayout>
                                  <button mat-icon-button (click)="markExtAsDelete(i)"><i class="mdi mdi-delete-outline"></i></button>
                                  <button mat-icon-button (click)="displayHints[anExt]=!displayHints[anExt]"><i class="mdi mdi-information-outline"></i></button>
                                </div>
                              </div>
                              <div *ngIf="displayHints[anExt]" class="hints" fxFlex>
                                <mat-chip-list aria-label="Fish selection">
                                  <mat-chip *ngFor="let aWord of possibleValues[anExt]" (click)="assignChipValueToText(anExt, aWord)">{{aWord}}</mat-chip>
                                </mat-chip-list>
                              </div>
                            </ng-container>


                            <div fxFlex="50px" class="text-right">
                              <button mat-raised-button class="mat-primary" (click)="addAnExt()">... create new one.</button>
                            </div>

                            <div *ngFor="let anExt of newExtProfils" fxLayout="row" fxLayoutAlign="start center">

                              <mat-form-field fxFlex="30" appearance="fill" class="w-100-p mr-8">
                                <mat-label>New Ext <span *ngIf="fNEditExt.get(anExt).dirty || fEditExt.get(anExt).dirty">[+]</span></mat-label>
                                <input placeholder="Type a new ext_key" matInput [formControl]="fNEditExt.get(anExt)">
                              </mat-form-field>

                              <mat-form-field fxFlex="60">
                                <input matInput [formControl]="fEditExt.get(anExt)">
                              </mat-form-field>

                              <div fxFlex="20" class="text-right">
                                <button mat-icon-button (click)="removeAnExt(anExt)"><i class="mdi mdi-delete-outline"></i></button>
                                <button mat-icon-button (click)="addAnExt()"><i class="mdi mdi-plus-circle-outline"></i></button>
                              </div>
                            </div>

                          </div>

                          <!--                  <div fxFlex="350px" style="overflow-y: auto;">-->
                          <!--                    <pre>(New) fNEditExt:{{fNEditExt.getRawValue()|json}}</pre>-->
                          <!--                    <pre>(All) fEditExt : {{fEditExt.getRawValue()|json}} </pre>-->
                          <!--                    <pre>To add : {{newExtProfilsIndex|json}} </pre>-->
                          <!--                    <pre>To delete:{{toDeleteExtProfils|json}}</pre>-->
                          <!--                    <pre>Edited ExtModified: {{editExtModified|json}}</pre>-->
                          <!--                  </div>-->

                          <div *ngIf="newExtProfilsIndex?.length > 0" fxFlex="45px" fxLayout="row">
                            <div fxFlex="grow"></div>
                            <mat-checkbox [formControl]="createLegacyEmailGroup.get(['create'])">Create a legacy email group</mat-checkbox>
                          </div>
                          <div *ngIf="createLegacyEmailGroup.get(['create']).value" fxFlex="45px" fxLayout="row" fxLayoutAlign="start center">
                            <div fxFlex fxLayout="column">
                              <div fxFlex>
                                Selected communities:
                              </div>
                              <app-communities-selector fxFlex [selectedCommunitiesId]="createLegacyEmailGroupCommunitiesIds" (selectionChanged)="changeLegacyCommunities($event)" [maxSel]="1"></app-communities-selector>
                            </div>
                            <div fxFlex>
                              <mat-form-field class="w-100-p">
                                <mat-label>Group label</mat-label>
                                <input matInput [formControl]="createLegacyEmailGroup.get(['groupCaption'])">
                              </mat-form-field>
                            </div>
                          </div>

                          <div fxFlex="50px" fxLayout="row" fxLayoutAlign="center end">
                            <div fxFlex>
                            </div>
                            <button [disabled]="editExtModifiedIndex?.length === 0 && toDeleteExtProfils?.length === 0"
                                    mat-raised-button class="mat-primary"
                                    (click)="updateExts()">Add or update
                            </button>
                          </div>

                        </div>

                      </ng-template>

                    </mat-tab>

                    <mat-tab label="Move to comunities">
                      <ng-template matTabContent>

                        <div fxLayout="column" class="ext-editor p-8 h-100-p w-100-p">
                          <div fxFlex="grow">
                            <div fxFlex fxLayout="column">
                              <div fxFlex>
                                Selected communities:
                              </div>
                              <app-communities-selector fxFlex (selectionChanged)="changeMoveToCommunities($event)"></app-communities-selector>
                            </div>
                          </div>

                          <div fxFlex="50px" fxLayout="row" fxLayoutAlign="center end">
                            <div fxFlex>
                            </div>
                            <button [disabled]="moveToCommunitiesIds?.length === 0"
                                    mat-raised-button class="mat-primary"
                                    (click)="moveToComunities()">Move to this communities
                            </button>
                          </div>

                        </div>

                      </ng-template>
                    </mat-tab>

                    <mat-tab label="Add credits">
                      <ng-template matTabContent>
                        <app-add-credit-to-contributors [selectedUsersId]="selectedUsersId"></app-add-credit-to-contributors>
                      </ng-template>
                    </mat-tab>

                  </mat-tab-group>

                </div>

              </ng-template>
            </e-pane>

          </e-panes>

        </ejs-splitter>

      </div>


      <div class="grid-container" *ngIf="uxInteractions.debugMode">
        <app-highlight [value]="uxInteractions.sqlFromService | sqlFormat"></app-highlight>
        <!--        <pre>{{uxInteractions.sqlFromService | sqlFormat }}</pre>-->
      </div>

    </div>
  </div>

  <mat-sidenav #settingsSidenav
               fuseMatSidenavHelper="user-admin-detail-sidenav"
               position="end"
               class="user-admin-detail-sidenav"
               (closed)="closeSideNav()"
               [opened]="uxInteractions.sideNav.open">

    <div class="grid-container" fxLayout="column" *ngIf="uxInteractions.sideNav.context === 'extSelector'">
      <div class="content grid-container">
        <mat-tab-group class="h-100-p">
          <mat-tab label="ExtProfils" class="h-100-p">
            <app-ext-profils-selector class="grid-container" fxFlex="grow" (selectionChange)="extProfilsSelectionChanged($event)" [selectedExtProfils]="selectedExtProfils"></app-ext-profils-selector>
          </mat-tab>

          <mat-tab label="Publication Context" class="h-100-p">
            <div class="h-100-p w-100-p p-16">
              <mat-checkbox [formControl]="modeTestSelected" class="block">
                <i class="mdi mdi-test-tube"></i> Mode test - (&debug=123)
              </mat-checkbox>
              <app-publication-selector class="p-4" (selectedPublicationChanged)="publicationChanged($event)"></app-publication-selector>
            </div>
          </mat-tab>

          <mat-tab label="Batch Select" class="h-100-p">
            <div fxLayout="column" class="h-100-p w-100-p p-16">

              <div fxFlex="120px">
                <app-communities-selector (selectionChanged)="communitiesToRefreshChanged($event)"></app-communities-selector>
              </div>

              <mat-form-field fxFlex class="w-100-p">
                <mat-label>User IDs</mat-label>
                <textarea [formControl]="batchUserSelectedId" matInput placeholder="Ex. 92;1085;3215;105014..." style="min-height:250px"></textarea>
              </mat-form-field>
              <pre>{{idSelected}}</pre>
              <mat-form-field fxFlex class="w-100-p">
                <mat-label>Emails</mat-label>
                <textarea [formControl]="batchUserSelectedEmails" matInput placeholder="Ex. toto@tutu.com;hell@titi.ca..." style="min-height:250px"></textarea>
              </mat-form-field>
              <pre>{{emailSelected}}</pre>
            </div>
          </mat-tab>


        </mat-tab-group>
      </div>

      <div fxFlex fxLayout="row" class="p-24">
        <span fxFlex="grow"></span>
        <button (click)="closeSideNav()" mat-button>Cancel</button>
        <button (click)="refresh(); closeSideNav();" mat-raised-button>Apply</button>
      </div>

    </div>

  </mat-sidenav>


</mat-sidenav-container>
